import { render, staticRenderFns } from "./StatisticLocationYear.vue?vue&type=template&id=bc1ee480&scoped=true"
import script from "./StatisticLocationYear.vue?vue&type=script&lang=js"
export * from "./StatisticLocationYear.vue?vue&type=script&lang=js"
import style0 from "./StatisticLocationYear.vue?vue&type=style&index=0&id=bc1ee480&prod&scoped=true&lang=scss"
import style1 from "./StatisticLocationYear.vue?vue&type=style&index=1&id=bc1ee480&prod&scoped=true&lang=css"
import style2 from "./StatisticLocationYear.vue?vue&type=style&index=2&id=bc1ee480&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1ee480",
  null
  
)

export default component.exports